export default "__VITE_ASSET__ChRpvFyv__"